/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionMode } from './PalAuthSubmissionMode';
import {
    PalAuthSubmissionModeFromJSON,
    PalAuthSubmissionModeFromJSONTyped,
    PalAuthSubmissionModeToJSON,
} from './PalAuthSubmissionMode';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
} from './PalAuthSubmissionStatusUpdatedByUser';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
} from './PalReauthCaseManager';
import type { PalReauthSubmissionListEntryLead } from './PalReauthSubmissionListEntryLead';
import {
    PalReauthSubmissionListEntryLeadFromJSON,
    PalReauthSubmissionListEntryLeadFromJSONTyped,
    PalReauthSubmissionListEntryLeadToJSON,
} from './PalReauthSubmissionListEntryLead';
import type { PalReauthSubmissionListEntryPayer } from './PalReauthSubmissionListEntryPayer';
import {
    PalReauthSubmissionListEntryPayerFromJSON,
    PalReauthSubmissionListEntryPayerFromJSONTyped,
    PalReauthSubmissionListEntryPayerToJSON,
} from './PalReauthSubmissionListEntryPayer';
import type { PalReauthSubmissionListEntryTimExecution } from './PalReauthSubmissionListEntryTimExecution';
import {
    PalReauthSubmissionListEntryTimExecutionFromJSON,
    PalReauthSubmissionListEntryTimExecutionFromJSONTyped,
    PalReauthSubmissionListEntryTimExecutionToJSON,
} from './PalReauthSubmissionListEntryTimExecution';
import type { PalReauthSubmissionStatus } from './PalReauthSubmissionStatus';
import {
    PalReauthSubmissionStatusFromJSON,
    PalReauthSubmissionStatusFromJSONTyped,
    PalReauthSubmissionStatusToJSON,
} from './PalReauthSubmissionStatus';
import type { PalReauthSubmissionStatusInfo } from './PalReauthSubmissionStatusInfo';
import {
    PalReauthSubmissionStatusInfoFromJSON,
    PalReauthSubmissionStatusInfoFromJSONTyped,
    PalReauthSubmissionStatusInfoToJSON,
} from './PalReauthSubmissionStatusInfo';
import type { PalReauthSubmissionTimingState } from './PalReauthSubmissionTimingState';
import {
    PalReauthSubmissionTimingStateFromJSON,
    PalReauthSubmissionTimingStateFromJSONTyped,
    PalReauthSubmissionTimingStateToJSON,
} from './PalReauthSubmissionTimingState';

/**
 * 
 * @export
 * @interface PalReauthSubmissionListEntry
 */
export interface PalReauthSubmissionListEntry {
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntry
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntry
     */
    pal_submission_id: string;
    /**
     * 
     * @type {PalReauthSubmissionStatus}
     * @memberof PalReauthSubmissionListEntry
     */
    status: PalReauthSubmissionStatus;
    /**
     * 
     * @type {PalReauthSubmissionStatusInfo}
     * @memberof PalReauthSubmissionListEntry
     */
    status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     * @type {PalReauthSubmissionStatusInfo}
     * @memberof PalReauthSubmissionListEntry
     */
    previous_status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntry
     */
    external_id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PalReauthSubmissionListEntry
     */
    next_review_date?: Date | null;
    /**
     * 
     * @type {PalReauthSubmissionTimingState}
     * @memberof PalReauthSubmissionListEntry
     */
    timing_state: PalReauthSubmissionTimingState;
    /**
     * 
     * @type {boolean}
     * @memberof PalReauthSubmissionListEntry
     */
    can_revert_status: boolean;
    /**
     * 
     * @type {PalReauthCaseManager}
     * @memberof PalReauthSubmissionListEntry
     */
    case_manager?: PalReauthCaseManager;
    /**
     * 
     * @type {PalAuthSubmissionStatusUpdatedByUser}
     * @memberof PalReauthSubmissionListEntry
     */
    status_updated_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     * @type {Date}
     * @memberof PalReauthSubmissionListEntry
     */
    date_created: Date;
    /**
     * 
     * @type {PalReauthSubmissionListEntryLead}
     * @memberof PalReauthSubmissionListEntry
     */
    lead?: PalReauthSubmissionListEntryLead;
    /**
     * 
     * @type {PalReauthSubmissionListEntryPayer}
     * @memberof PalReauthSubmissionListEntry
     */
    payer?: PalReauthSubmissionListEntryPayer;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntry
     */
    auth_platform_name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PalReauthSubmissionListEntry
     */
    is_oon?: boolean;
    /**
     * 
     * @type {PalReauthSubmissionListEntryTimExecution}
     * @memberof PalReauthSubmissionListEntry
     */
    tim_execution?: PalReauthSubmissionListEntryTimExecution;
    /**
     * 
     * @type {PalAuthSubmissionMode}
     * @memberof PalReauthSubmissionListEntry
     */
    submission_mode?: PalAuthSubmissionMode;
    /**
     * 
     * @type {boolean}
     * @memberof PalReauthSubmissionListEntry
     */
    is_non_submission_flow?: boolean;
}

/**
 * Check if a given object implements the PalReauthSubmissionListEntry interface.
 */
export function instanceOfPalReauthSubmissionListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "pal_submission_id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "timing_state" in value;
    isInstance = isInstance && "can_revert_status" in value;
    isInstance = isInstance && "date_created" in value;

    return isInstance;
}

export function PalReauthSubmissionListEntryFromJSON(json: any): PalReauthSubmissionListEntry {
    return PalReauthSubmissionListEntryFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'pal_submission_id': json['pal_submission_id'],
        'status': PalReauthSubmissionStatusFromJSON(json['status']),
        'status_info': !exists(json, 'status_info') ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['status_info']),
        'previous_status_info': !exists(json, 'previous_status_info') ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['previous_status_info']),
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'next_review_date': !exists(json, 'next_review_date') ? undefined : (json['next_review_date'] === null ? null : new Date(json['next_review_date'])),
        'timing_state': PalReauthSubmissionTimingStateFromJSON(json['timing_state']),
        'can_revert_status': json['can_revert_status'],
        'case_manager': !exists(json, 'case_manager') ? undefined : PalReauthCaseManagerFromJSON(json['case_manager']),
        'status_updated_by_user': !exists(json, 'status_updated_by_user') ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_updated_by_user']),
        'date_created': (new Date(json['date_created'])),
        'lead': !exists(json, 'lead') ? undefined : PalReauthSubmissionListEntryLeadFromJSON(json['lead']),
        'payer': !exists(json, 'payer') ? undefined : PalReauthSubmissionListEntryPayerFromJSON(json['payer']),
        'auth_platform_name': !exists(json, 'auth_platform_name') ? undefined : json['auth_platform_name'],
        'is_oon': !exists(json, 'is_oon') ? undefined : json['is_oon'],
        'tim_execution': !exists(json, 'tim_execution') ? undefined : PalReauthSubmissionListEntryTimExecutionFromJSON(json['tim_execution']),
        'submission_mode': !exists(json, 'submission_mode') ? undefined : PalAuthSubmissionModeFromJSON(json['submission_mode']),
        'is_non_submission_flow': !exists(json, 'is_non_submission_flow') ? undefined : json['is_non_submission_flow'],
    };
}

export function PalReauthSubmissionListEntryToJSON(value?: PalReauthSubmissionListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'pal_submission_id': value.pal_submission_id,
        'status': PalReauthSubmissionStatusToJSON(value.status),
        'status_info': PalReauthSubmissionStatusInfoToJSON(value.status_info),
        'previous_status_info': PalReauthSubmissionStatusInfoToJSON(value.previous_status_info),
        'external_id': value.external_id,
        'next_review_date': value.next_review_date === undefined ? undefined : (value.next_review_date === null ? null : value.next_review_date.toISOString().substring(0,10)),
        'timing_state': PalReauthSubmissionTimingStateToJSON(value.timing_state),
        'can_revert_status': value.can_revert_status,
        'case_manager': PalReauthCaseManagerToJSON(value.case_manager),
        'status_updated_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value.status_updated_by_user),
        'date_created': (value.date_created.toISOString()),
        'lead': PalReauthSubmissionListEntryLeadToJSON(value.lead),
        'payer': PalReauthSubmissionListEntryPayerToJSON(value.payer),
        'auth_platform_name': value.auth_platform_name,
        'is_oon': value.is_oon,
        'tim_execution': PalReauthSubmissionListEntryTimExecutionToJSON(value.tim_execution),
        'submission_mode': PalAuthSubmissionModeToJSON(value.submission_mode),
        'is_non_submission_flow': value.is_non_submission_flow,
    };
}

